import { useEffect, useState } from 'react';
import Async from 'react-select/async';
import type { IReactSelectOptions } from '../../../../interfaces/reactSelectOptions';
import { translateKey } from '../../../../../translate';
import { Feedback } from '../../../../elements/common';
import { SelectOption } from '../../../../elements/SelectOption';

interface ISettingsSearchableDropDownProps {
    defaultOptions?: IReactSelectOptions[] | boolean;
    error: string | undefined;
    isClearable?: boolean;
    loadOptions: (searchText: string) => Promise<IReactSelectOptions[]>;
    onChange: (selectedOption: string) => void;
    value: string | undefined;
}

export function SettingsSearchableDropDown(props: ISettingsSearchableDropDownProps) {
    const [selectedOption, setSelectedOption] = useState<{ label: string; value: string } | null | undefined>();
    const [options, setOptions] = useState<IReactSelectOptions[]>();

    useEffect(() => {
        findSelectedOption();
    }, [props.value, options]);

    return (
        <>
            <Async<IReactSelectOptions>
                className="select-form-control-ds"
                classNamePrefix="Select"
                components={{ Option: SelectOption }}
                defaultOptions={props.defaultOptions || true}
                isClearable={props.isClearable}
                loadOptions={loadOptions}
                noOptionsMessage={() => translateKey('common.typeToSearch')}
                onChange={(option) => {
                    if (option && !Array.isArray(option)) {
                        props.onChange(option.value);
                    }
                }}
                value={selectedOption}
            />
            <Feedback error={props.error} />
        </>
    );

    function findSelectedOption() {
        if (!props.value) {
            setSelectedOption(null);
        }

        setSelectedOption(options?.find((option) => option.value === props.value));
    }

    async function loadOptions(searchText: string) {
        const loadedOptions = await props.loadOptions(searchText);
        setOptions(loadedOptions);

        return loadedOptions;
    }
}
